export { isReducedMotion } from '../utils/is-reduced-motion';
export { useIsReducedMotion } from '../utils/use-is-reduced-motion';
export { prefersReducedMotion } from '../utils/accessibility';
export { reduceMotionAsPerUserPreference } from '../utils/reduce-motion-as-per-user-preference';
